import React, { useCallback, useEffect } from 'react';
import { Button } from '../../components/Button/Button';
import changePasswordSuccessImage from '../../assets/images/change-password-success.png';
import { useLanguage } from '../../locale/useLanguage';
import { useHistory, useLocation } from 'react-router-dom';
import { Routes } from '../../routes/types';

import './ChangePasswordSuccessView.css';

type ChangePasswordSuccessViewRouteParams =
  | {
      isFromChangePassword: boolean;
    }
  | undefined;

type ChangePasswordSuccessViewProps = {};

export const ChangePasswordSuccessView: React.FC<
  ChangePasswordSuccessViewProps
> = () => {
  const [t] = useLanguage();
  const history = useHistory();
  const location = useLocation<ChangePasswordSuccessViewRouteParams>();

  useEffect(() => {
    if (!location.state?.isFromChangePassword) {
      history.replace(Routes.Home);
    }
  }, [history, location.state?.isFromChangePassword]);

  const goToSignIn = useCallback(() => {
    history.replace(Routes.SignIn);
  }, [history]);

  return (
    <div className="change-password-success--container">
      <div className="change-password-success--body">
        <div className="change-password-success--content">
          <img
            className="change-password-success--image"
            src={changePasswordSuccessImage}
          />
          <h3>{t('recoveryPasswordSuccess.title')}</h3>
          <p className="change-password-success--description">
            {t('recoveryPasswordSuccess.description')}
          </p>
        </div>
        <div>
          <Button
            onClick={goToSignIn}
            isWhite
            label={t('recoveryPasswordSuccess.signIn')}
          />
        </div>
      </div>
    </div>
  );
};
